import React from "react";
import { Card, CardContent } from "@/components/ui/card";

export function KpiCard({ label, value, sub, icon: Icon, accent = "navy", testId, delay = 0 }) {
  const accents = {
    navy: "text-[#18344A] bg-[rgba(24,52,74,0.08)]",
    blue: "text-[#526E7E] bg-[rgba(82,110,126,0.12)]",
    sand: "text-[#7a6a4f] bg-[rgba(183,165,142,0.22)]",
    muted: "text-[#78909C] bg-[rgba(120,144,156,0.16)]",
  };
  return (
    <Card
      data-testid={testId}
      className="rounded-[14px] border-[var(--pb-border)] bg-white shadow-[var(--pb-shadow-sm)] transition-shadow hover:shadow-[var(--pb-shadow-md)] animate-fade-up"
      style={{ animationDelay: `${delay}ms` }}
    >
      <CardContent className="p-5">
        <div className="flex items-start justify-between">
          <span className="text-xs font-medium tracking-wide text-[rgba(48,56,60,0.72)]">{label}</span>
          {Icon && (
            <span className={`flex h-9 w-9 items-center justify-center rounded-[10px] ${accents[accent]}`}>
              <Icon className="h-4 w-4" />
            </span>
          )}
        </div>
        <div className="mt-3 font-num text-2xl sm:text-3xl font-semibold text-[#30383C]">{value}</div>
        {sub && <div className="mt-1 text-xs text-[rgba(48,56,60,0.6)]">{sub}</div>}
      </CardContent>
    </Card>
  );
}
